import React, { Component } from "react";
import { Form } from "react-bootstrap";
import { get, sortBy, groupBy } from "lodash";
import { bindActionCreators } from "redux";
import { guestListAction } from "../../actions/issuesListAction.actions";
import { connect } from "react-redux";
import { GROUP_CATEGORY } from "../../constant";
import { OverlayTrigger, Tooltip, Image } from "react-bootstrap";
import NodalOfficer from "../../assets/nodal.svg";
import { LocalConvenienceStoreOutlined } from "@material-ui/icons";

class Guests extends Component {
  distinctOnBasisOfGroupId = user => {
    const distinctGroup = {};
    (user || []).forEach(value => {
      value.emailType = value.emailType || "CC";
      value.userName = value.name || "NA";
      value.designation = value.designation || "NA";
      value.groupName = value.groupName || "NA";
      value.guestCategory = value.guestCategory || "NA";
      distinctGroup[value.guestCategory] =
        distinctGroup[value.guestCategory] || [];
      distinctGroup[value.guestCategory].push(value);
    });
    return Object.values(distinctGroup);
  };

  render() {
    const { users, guests } = this.props;

    // Remove duplicate user
    const removeDuplicatePmgUser = users.filter((item, index, self) => {
      return (
        item.guestCategory !== "PMG" ||
        item.emailType !== "TO" ||
        index === self.findIndex(t => t.email === item.email)
      );
    });

    const filterAndMergeUsers = users => {
      const ppUsers = users.filter(item => item.guestCategory === "PP");
      const otherUsers = users.filter(item => item.guestCategory !== "PP");
      const userIdCounts = {};
      const duplicateUsers = [];
      const uniqueUsers = [];

      // Count the occurrences of each userId
      for (const user of ppUsers) {
        if (user.userId in userIdCounts) {
          userIdCounts[user.userId]++;
        } else {
          userIdCounts[user.userId] = 1;
        }
      }

      // Separate the users based on occurrence count
      for (const user of ppUsers) {
        if (userIdCounts[user.userId] > 1) {
          if (user.emailType !== "CC") {
            duplicateUsers.push(user);
          }
        } else {
          uniqueUsers.push(user);
        }
      }
      const mergedUsers = [...uniqueUsers, ...otherUsers, ...duplicateUsers];

      return mergedUsers;
    };
    const mergedUsers = filterAndMergeUsers(removeDuplicatePmgUser);

    return (
      <React.Fragment>
        <>
          {this.distinctOnBasisOfGroupId(mergedUsers || []).map((user, idx) => {
            return (
              <div class="selected-list-container" key={`user-key-${idx}`}>
                <div class="selected-list">
                  {GROUP_CATEGORY[get(user[0], "guestCategory", "NA")]}
                </div>
                <div className="user-detail-container">
                  <Form className="guest-list-form">
                    <Form.Group controlId="checkbox">
                      {Object.keys(groupBy(user, "groupName")).map(
                        (item, index) => {
                          return (
                            <>
                              <div className="user-ministry">
                                <div className="mb-3">{item}</div>
                                {groupBy(user, "groupName")[item].map(
                                  (value, userIdx) => {
                                    return (
                                      <Form.Text key={`user--${userIdx}`}>
                                        <div className="d-flex justify-content-between scheduled-user-name">
                                          <OverlayTrigger
                                            placement="bottom-start"
                                            overlay={
                                              <Tooltip
                                                id="tooltip-pdf"
                                                placement="bottom-start"
                                                className={`issues-actions-tooltip ${""}`}
                                              >
                                                {`${get(
                                                  value,
                                                  "designation",
                                                  "NA"
                                                )}`}
                                              </Tooltip>
                                            }
                                          >
                                            <div className="selected-user-detail">
                                              {value.nodalOfficer === true ? (
                                                <Image
                                                  src={NodalOfficer}
                                                  className="nodal-officer-icon mr-2"
                                                />
                                              ) : null}
                                              {get(value, "userName", "NA")}
                                            </div>
                                          </OverlayTrigger>

                                          <div className="sender-text">
                                            {get(value, "emailType", "NA")}
                                          </div>
                                        </div>
                                      </Form.Text>
                                    );
                                  }
                                )}
                              </div>
                            </>
                          );
                        }
                      )}
                    </Form.Group>
                  </Form>
                </div>
              </div>
            );
          })}
        </>
        {(guests || []).map((guest, guestIndex) => (
          <div class="selected-list-container" key={`guestIndex-${guestIndex}`}>
            <div class="selected-list">Others</div>
            <Form className="guest-list-form">
              <Form.Group controlId="checkbox">
                <Form.Text>
                  <div className="d-flex justify-content-between mt-2 p-3">
                    <div className="selected-user-detail">{guest.email}</div>
                    <div className="sender-text">{guest.emailType}</div>
                  </div>
                </Form.Text>
              </Form.Group>
            </Form>
          </div>
        ))}
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    guestListData: state.issueActionReducer.guestListData
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      guestListDispatch: guestListAction
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Guests);
